import React, { useEffect, useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, Chip, Tab, Tabs, FormControl, FormLabel, Box } from '@mui/material';
import { buttonStyles, htmlToPlainText, multilineTextFieldStyles, smallOutlinedInputStyles, tabFormLabelStyles, thumbnailOverlayButtonStyles, scrollbarStyles } from '../utils/constant';

const EditShowModal = ({ open, handleClose, showDetails, handleSave }) => {
    const [updatedDetails, setUpdatedDetails] = useState(showDetails);
    const [selectedTab, setSelectedTab] = useState(0);
    const [newTag, setNewTag] = useState('');
    const [showOverlay, setShowOverlay] = React.useState(false);
    const [isAutoGeneratePopupOpen, setAutoGeneratePopupOpen] = useState(false);
    const [selectedThumbnail, setSelectedThumbnail] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUpdatedDetails((prevDetails) => ({
            ...prevDetails,
            [name]: value
        }));
    };

    const handleThumbnailSelection = () => {
        if (selectedThumbnail) {
          console.log('Selected Thumbnail:', selectedThumbnail);
          // You can perform other actions like saving the selected thumbnail to a backend or state
          setUpdatedDetails((prevDetails) => ({
            ...prevDetails,
            Thumbnail: selectedThumbnail.ThumbnailURL, // Update the Thumbnail with base64 string
            uploadType: "s3Key",
            ThumbnailBucket: selectedThumbnail.ThumbnailBucket,
            ThumbnailKey: selectedThumbnail.ThumbnailKey
        }));
        }
        setAutoGeneratePopupOpen(false)
      };

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    const handleNewTagChange = (e) => {
        setNewTag(e.target.value); // Update the newTag state as user types
    };

    const handleAddTag = (e) => {
        if (e.key === 'Enter' && newTag.trim()) {
            // Add the tag to the list if it's not empty
            setUpdatedDetails((prevDetails) => ({
                ...prevDetails,
                Tags: [...prevDetails.Tags, newTag.trim()],
            }));
            setNewTag(''); // Reset the newTag input field
        }
    };

    const handleDeleteTag = (tagToDelete) => {
        setUpdatedDetails((prevDetails) => ({
            ...prevDetails,
            Tags: prevDetails.Tags.filter((tag) => tag !== tagToDelete),
        }));
    };

    const handleSubmit = () => {
        handleSave(updatedDetails); // Pass updated details to the parent component
        handleClose(); // Close the modal
    };

    useEffect(() => {
        if (open) {
            setUpdatedDetails(showDetails);
        }
    }, [open, showDetails]);

    const handleThumbnailChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64Image = reader.result;
                setUpdatedDetails((prevDetails) => ({
                    ...prevDetails,
                    Thumbnail: base64Image, // Update the Thumbnail with base64 string
                    uploadType: "base64"
                }));
            };
            reader.readAsDataURL(file); // Read the file as a base64 string
        }
    };
    const handleAutoGenerateThumbnail = () => {
        console.log('Thumbnail auto-generated');
        setAutoGeneratePopupOpen(true); // Open the popup when the button is clicked
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth={false}
            sx={{
                '& .MuiPaper-root': {
                    backgroundColor: '#000029',
                    color: 'white',
                    borderRadius: '1.6vh',
                    boxShadow: '0 0.4vh 1.2vh rgba(0, 0, 0, 0.4)',
                    width: '85vw',
                    height: '85vh',
                    maxWidth: '85vw',
                    maxHeight: '85vh',
                    display: 'flex',
                    flexDirection: 'column',
                    ...scrollbarStyles,
                },
                '& .MuiDialogContent-root': {
                    padding: '2vh',
                    overflow: 'hidden',
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                },
                '& .MuiDialogTitle-root': {
                    padding: '2vh',
                    fontSize: '2.4vh',
                    fontWeight: 'bold',
                    flexShrink: 0,
                },
                '& .MuiDialogActions-root': {
                    padding: '1.5vh 2vh',
                    gap: '1vh',
                    flexShrink: 0,
                }
            }}>
            <DialogTitle>Edit Show Details</DialogTitle>
            <DialogContent>
                <div style={{ display: 'flex', flexDirection: 'row', height: '100%', gap: '2vh' }}>
                    {/* Left side: Thumbnail and Show Name / Tags */}
                    <Box sx={{
                        width: '28%',
                        borderRight: '0.15vh solid rgba(255, 255, 255, 0.2)',
                        paddingRight: '2vh',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '1.5vh',
                        minHeight: 0,
                        overflowY: 'auto',
                        ...scrollbarStyles,
                    }}
                    >
                        {/* Thumbnail */}
                        <div
                            style={{
                                position: 'relative',
                                width: '100%',
                                height: '22vh',
                                borderRadius: '1.2vh',
                                overflow: 'hidden',
                                flexShrink: 0,
                                boxShadow: '0 0.2vh 0.8vh rgba(0, 0, 0, 0.3)',
                            }}
                            onMouseEnter={() => setShowOverlay(true)}
                            onMouseLeave={() => setShowOverlay(false)}
                        >
                            {updatedDetails?.Thumbnail ? (
                                <img
                                    src={updatedDetails.Thumbnail}
                                    alt="Show Thumbnail"
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                        borderRadius: '1.2vh',
                                    }}
                                />
                            ) : (
                                <div
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        color: 'rgba(255, 255, 255, 0.5)',
                                        fontSize: '1.6vh',
                                        fontWeight: 'normal',
                                        textAlign: 'center',
                                        borderRadius: '1.2vh',
                                    }}
                                >
                                    Thumbnail not available
                                </div>
                            )}
                            <input
                                id="thumbnail-upload"
                                type="file"
                                accept="image/*"
                                style={{ display: 'none' }}
                                onChange={handleThumbnailChange}
                            />
                            {/* Overlay and buttons */}
                            {showOverlay && (
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        borderRadius: '1.2vh',
                                        gap: '1vh',
                                    }}
                                >
                                    <button
                                        style={thumbnailOverlayButtonStyles}
                                        onClick={() => document.getElementById('thumbnail-upload').click()}
                                    >
                                        File Upload
                                    </button>
                                    <button
                                        style={thumbnailOverlayButtonStyles}
                                        onClick={handleAutoGenerateThumbnail}
                                    >
                                        Auto Generate
                                    </button>
                                </div>
                            )}
                        </div>

                        {/* Show Name and Tags */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '1vh', flexShrink: 0 }}>
                            <FormControl fullWidth>
                                <FormLabel sx={{ color: '#FFFFFF', fontSize: '1.4vh', fontWeight:'100', marginBottom: '0.3vh', marginLeft: '1.2vh' }}>
                                    Show Name
                                </FormLabel>
                                <TextField
                                    fullWidth
                                    name="ShowName"
                                    placeholder="Enter show name"
                                    value={updatedDetails?.ShowName || ''}
                                    onChange={handleChange}
                                    variant="outlined"
                                    sx={smallOutlinedInputStyles}
                                />
                            </FormControl>
                            <FormControl fullWidth>
                                <FormLabel sx={{ color: '#FFFFFF', fontSize: '1.4vh', fontWeight:'100', marginBottom: '0.3vh', marginLeft: '1.2vh' }}>
                                    Tags
                                </FormLabel>
                                <TextField
                                    fullWidth
                                    placeholder="Enter tag and press Enter"
                                    value={newTag}
                                    onChange={handleNewTagChange}
                                    onKeyPress={handleAddTag}
                                    variant="outlined"
                                    sx={smallOutlinedInputStyles}
                                />
                            </FormControl>
                        </div>

                        {/* Tags Display with scroll if needed */}
                        <div style={{ 
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '0.8vh',
                            flexShrink: 0,
                        }}>
                            {updatedDetails?.Tags?.map((tag, index) => (
                                <Chip
                                    key={index}
                                    label={tag}
                                    onDelete={() => handleDeleteTag(tag)}
                                    sx={{
                                        backgroundColor: 'rgba(25, 118, 210, 0.15)',
                                        color: '#ffffff',
                                        border: '0.1vh solid rgba(25, 118, 210, 0.5)',
                                        fontSize: '1.3vh',
                                        height: '3vh',
                                        transition: 'all 0.2s ease',
                                        '&:hover': {
                                            backgroundColor: 'rgba(25, 118, 210, 0.25)',
                                            borderColor: 'rgba(25, 118, 210, 0.7)',
                                        },
                                        '& .MuiChip-label': {
                                            padding: '0 1.2vh',
                                        },
                                        '& .MuiChip-deleteIcon': {
                                            color: 'rgba(255, 255, 255, 0.6)',
                                            fontSize: '1.6vh',
                                            transition: 'color 0.2s ease',
                                            '&:hover': {
                                                color: '#ffffff',
                                            }
                                        }
                                    }}
                                />
                            ))}
                        </div>
                    </Box>

                    {/* Right side: Tabs */}
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                        <Tabs 
                            value={selectedTab} 
                            onChange={handleTabChange} 
                            aria-label="edit show details tabs" 
                            sx={{
                                minHeight: '5vh',
                                borderBottom: '0.1vh solid rgba(255, 255, 255, 0.1)',
                                marginBottom: '1vh',
                                '& .MuiTabs-indicator': {
                                    backgroundColor: '#1976d2',
                                    height: '0.3vh',
                                    borderRadius: '0.3vh 0.3vh 0 0',
                                },
                                '& .MuiTabs-flexContainer': {
                                    gap: '0.5vh',
                                },
                                '& .MuiTab-root': {
                                    color: 'rgba(255, 255, 255, 0.5)',
                                    fontSize: '1.5vh',
                                    textTransform: 'none',
                                    fontWeight: 400,
                                    minHeight: '4.5vh',
                                    padding: '1vh 2vh',
                                    borderRadius: '0.8vh 0.8vh 0 0',
                                    transition: 'all 0.3s ease',
                                    minWidth: 'auto',
                                    '&:hover': {
                                        color: 'rgba(255, 255, 255, 0.8)',
                                        backgroundColor: 'rgba(255, 255, 255, 0.05)',
                                    },
                                    '&.Mui-selected': {
                                        color: '#ffffff',
                                        fontWeight: 500,
                                        backgroundColor: 'rgba(25, 118, 210, 0.08)',
                                    }
                                }
                            }}
                        >
                            <Tab label="Summary" />
                            <Tab label="Transcript" />
                            <Tab label="Agenda" />
                            <Tab label="Guest Details" />
                        </Tabs>

                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                            {/* Tab Content */}
                            {selectedTab === 0 && (
                                <FormControl fullWidth sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                                    <FormLabel sx={tabFormLabelStyles}>Summary</FormLabel>
                                    <TextField
                                        fullWidth
                                        name="summary"
                                        placeholder="Enter summary"
                                        value={updatedDetails?.summary || ''}
                                        onChange={handleChange}
                                        multiline
                                        variant="outlined"
                                        InputProps={{ style: { padding: 0 } }}
                                        sx={multilineTextFieldStyles}
                                    />
                                </FormControl>
                            )}
                            {selectedTab === 1 && (
                                <FormControl fullWidth sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                                    <FormLabel sx={tabFormLabelStyles}>Transcript</FormLabel>
                                    <TextField
                                        fullWidth
                                        name="Transcript"
                                        placeholder="Enter transcript"
                                        value={updatedDetails?.Transcript || ''}
                                        onChange={handleChange}
                                        multiline
                                        variant="outlined"
                                        InputProps={{ style: { padding: 0 } }}
                                        sx={multilineTextFieldStyles}
                                    />
                                </FormControl>
                            )}
                            {selectedTab === 2 && (
                                <FormControl fullWidth sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                                    <FormLabel sx={tabFormLabelStyles}>Agenda</FormLabel>
                                    <TextField
                                        fullWidth
                                        name="Agenda"
                                        placeholder="Enter agenda"
                                        value={htmlToPlainText(updatedDetails?.Agenda) || ''}
                                        onChange={handleChange}
                                        multiline
                                        variant="outlined"
                                        InputProps={{ style: { padding: 0 } }}
                                        sx={multilineTextFieldStyles}
                                    />
                                </FormControl>
                            )}
                            {selectedTab === 3 && (
                                <FormControl fullWidth sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                                    <FormLabel sx={tabFormLabelStyles}>Guest Details</FormLabel>
                                    <TextField
                                        fullWidth
                                        name="GuestInfo"
                                        placeholder="Enter guest details"
                                        value={htmlToPlainText(updatedDetails?.GuestInfo) || ''}
                                        onChange={handleChange}
                                        multiline
                                        variant="outlined"
                                        InputProps={{ style: { padding: 0 } }}
                                        sx={multilineTextFieldStyles}
                                    />
                                </FormControl>
                            )}
                        </div>
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <Button 
                    onClick={handleClose} 
                    sx={{
                        background: 'transparent',
                        border: '0.1vh solid rgba(255, 255, 255, 0.5)',
                        color: '#ffffff',
                        padding: '0.8vh 2.4vh',
                        fontSize: '1.6vh',
                        borderRadius: '1.2vh',
                        textTransform: 'none',
                        letterSpacing: '0.032vh',
                        minWidth: '12vh',
                        '&:hover': {
                            background: 'transparent',
                            borderColor: 'rgba(255, 255, 255, 0.8)',
                        }
                    }}
                >
                    Cancel
                </Button>
                <Button 
                    onClick={handleSubmit}
                    variant="contained"
                    sx={{
                        ...buttonStyles.primary,
                        minWidth: '12vh',
                    }}
                >
                    Save
                </Button>
            </DialogActions>
            <Dialog
                open={isAutoGeneratePopupOpen}
                onClose={() => setAutoGeneratePopupOpen(false)}
                sx={{
                    '& .MuiBackdrop-root': {
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    },
                    '& .MuiPaper-root': {
                        backgroundColor: '#000029',
                        color: 'white',
                        borderRadius: '1.6vh',
                        boxShadow: '0 0.4vh 1.2vh rgba(0, 0, 0, 0.4)',
                        marginLeft: '28%',
                        width: '60vw',
                        maxWidth: '60vw',
                        ...scrollbarStyles,
                    },
                    '& .MuiDialogTitle-root': {
                        padding: '2vh',
                        fontSize: '2.4vh',
                        fontWeight: 'bold',
                    },
                    '& .MuiDialogContent-root': {
                        padding: '2vh',
                        maxHeight: '60vh',
                        overflowY: 'auto',
                        ...scrollbarStyles,
                    },
                    '& .MuiDialogActions-root': {
                        padding: '1.5vh 2vh',
                        gap: '1vh',
                    }
                }}
                maxWidth={false}
            >
                <DialogTitle>Auto-generated Thumbnails</DialogTitle>
                <DialogContent>
                    {!updatedDetails?.thumbnailImages || updatedDetails.thumbnailImages.length === 0 ? (
                        <div style={{ 
                            textAlign: 'center', 
                            padding: '3vh 2vh',
                            color: 'rgba(255, 255, 255, 0.7)',
                            fontSize: '1.6vh'
                        }}>
                            <p>It looks like there is no thumbnail for this show. Feel free to upload one if you'd like!</p>
                        </div>
                    ) : (
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(20vh, 1fr))', gap: '2vh', padding: '1vh' }}>
                            {updatedDetails?.thumbnailImages.map((video, index) => (
                                <div
                                    key={index}
                                    onClick={() => setSelectedThumbnail(video)}
                                    style={{
                                        cursor: 'pointer',
                                        border: selectedThumbnail?.ThumbnailURL === video.ThumbnailURL 
                                            ? '0.3vh solid #1976d2' 
                                            : '0.1vh solid rgba(255, 255, 255, 0.2)',
                                        borderRadius: '1.2vh',
                                        overflow: 'hidden',
                                        transition: 'all 0.3s ease',
                                        backgroundColor: selectedThumbnail?.ThumbnailURL === video.ThumbnailURL 
                                            ? 'rgba(25, 118, 210, 0.1)' 
                                            : 'transparent',
                                        padding: '1vh',
                                    }}
                                    onMouseEnter={(e) => {
                                        if (selectedThumbnail?.ThumbnailURL !== video.ThumbnailURL) {
                                            e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.5)';
                                            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.05)';
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (selectedThumbnail?.ThumbnailURL !== video.ThumbnailURL) {
                                            e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.2)';
                                            e.currentTarget.style.backgroundColor = 'transparent';
                                        }
                                    }}
                                >
                                    <img
                                        src={video.ThumbnailURL}
                                        alt={`Thumbnail ${index + 1}`}
                                        style={{ 
                                            width: '100%', 
                                            height: '15vh', 
                                            objectFit: 'cover',
                                            borderRadius: '0.8vh',
                                        }}
                                    />
                                </div>
                            ))}
                        </div>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button 
                        onClick={() => setAutoGeneratePopupOpen(false)}
                        sx={{
                            background: 'transparent',
                            border: '0.1vh solid rgba(255, 255, 255, 0.5)',
                            color: '#ffffff',
                            padding: '0.8vh 2.4vh',
                            fontSize: '1.6vh',
                            borderRadius: '1.2vh',
                            textTransform: 'none',
                            letterSpacing: '0.032vh',
                            minWidth: '12vh',
                            '&:hover': {
                                background: 'transparent',
                                borderColor: 'rgba(255, 255, 255, 0.8)',
                            }
                        }}
                    >
                        Close
                    </Button>
                    {selectedThumbnail && (
                        <Button 
                            onClick={handleThumbnailSelection}
                            sx={{
                                padding: '0.8vh 2.4vh',
                                fontSize: '1.6vh',
                                borderRadius: '1.2vh',
                                letterSpacing: '0.032vh',
                                textTransform: 'none',
                                background: 'linear-gradient(to right, #472DDB, #0985FB, #00D7FD)',
                                color: '#ffffff',
                                minWidth: '12vh',
                            }}
                        >
                            Confirm Selection
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
        </Dialog>
    );
};

export default EditShowModal;
